export default __webpack_public_path__ + "static/media/NavHomePoint.4f479e17.png";